/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/camelcase */
<template>
  <!-- //TODO: show the selected tags -->
  <!-- // Have update button rather then save -->
  <!-- todo: Show default selected image -->
  <div class="">
    <section class="title">
      <div class="header__text-box">
        <h1 class="heading-primary">
          <span
            v-if="editMode"
            class="heading-primary--main"
          >Edit a Blog</span>
          <span
            v-if="!editMode"
            class="heading-primary--main"
          >Create a Blog</span>
        </h1>
      </div>
    </section>
    <Crumbs />
    <section
      v-if="editMode"
      class="section-create-blog"
    >
      <EditBlog />
    </section>
    <section
      v-if="!editMode"
      class="section-create-blog"
    >
      <MakeBlog />
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import EditBlog from '@/components/admin/admin/Blog/EditBlog'
import MakeBlog from '@/components/admin/admin/Blog/MakeBlog'
import Crumbs from '@/components/layout/Crumbs'
export default {
  components: {
    EditBlog,
    MakeBlog,
    Crumbs
  },
  data () {
    return {
      editMode: null,
      editBlog: null
    }
  },
  mounted () {
    if (this.$route.params.blog) {
      this.editMode = true
      this.editBlog = this.$route.params.blog
    }
  }
}
</script>
